import axios from 'axios';
import cfac22 from '../cfac22';

export const insertUserOrgs = async (uId, orgID) => {
  try {
    const endpoint = `${cfac22('API_HOST_V2')}/organizations/user/insert`;
    const response = await axios.post(
      endpoint,
      { uId, orgID },
      {
        headers: {
          'Full-Url': window.location.href,
        },
                withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error?.response || error;
  }
};


